const IMAGE_CODES = {
  'Storage Tank Fixed Roof': {
    'API 653': [
      { code: 'AS', description: 'Access Structure' },
      { code: 'B', description: 'Bund Area and Containment' },
      { code: 'FRE', description: 'External Fixed Roof' },
      { code: 'FRI', description: 'Internal Fixed Roof' },
      { code: 'RA', description: 'Roof Appurtenances' },
      { code: 'SA', description: 'Shell Appurtenances' },
      { code: 'SE', description: 'Shell External' },
      { code: 'SI', description: 'Shell Internal' },
      { code: 'TF', description: 'Tank Foundation' },
      { code: 'TFA', description: 'Tank Floor and Internal Appurtenances' },
    ],

    'EEMUA 159': [
      { code: 'BE', description: 'Tank Bottom (External)' },
      { code: 'BI', description: 'Tank Bottom (Internal)' },
      { code: 'F', description: 'Foundation Pit' },
      { code: 'LFR', description: 'Lightweight Floating Roof (Internal)' },
      { code: 'P', description: 'Pipes (External)' },
      { code: 'RE', description: 'Tank Roof Fixed (External)' },
      { code: 'RI', description: 'Tank Roof Fixed (Internal)' },
      { code: 'SE', description: 'Tank Shell (External)' },
      { code: 'SI', description: 'Tank Shell (Internal)' },
    ],
  },

  'Storage Tank Floating Roof': {
    'API 653': [
      { code: 'AS', description: 'Access Structure' },
      { code: 'B', description: 'Bund Area and Containment' },
      { code: 'FRE', description: 'External Floating Roof' },
      { code: 'FRI', description: 'Internal Floating Roof' },
      { code: 'SA', description: 'Shell Appurtenances' },
      { code: 'SE', description: 'Shell External' },
      { code: 'SI', description: 'Shell Internal' },
      { code: 'TF', description: 'Tank Foundation' },
      { code: 'TFA', description: 'Tank Floor and Internal Appurtenances' },
    ],

    'EEMUA 159': [
      { code: 'BE', description: 'Tank Bottom (External)' },
      { code: 'BI', description: 'Tank Bottom (Internal)' },
      { code: 'F', description: 'Foundation Pit' },
      { code: 'FRE', description: 'Tank Roof Floating (External)' },
      { code: 'FRI', description: 'Tank Roof Floating (Internal)' },
      { code: 'LFR', description: 'Lightweight Floating Roof (Internal)' },
      { code: 'P', description: 'Pipes (External)' },
      { code: 'SE', description: 'Tank Shell (External)' },
      { code: 'SI', description: 'Tank Shell (Internal)' },
    ],
  },

  'Piping Systems': {
    'API 570': [
      { code: 'A', description: 'Pipeline General' },
      { code: 'B', description: 'Supports' },
      { code: 'C', description: 'Drain Points' },
      { code: 'D', description: 'Insulation' },
      { code: 'E', description: 'Road and Bund Wall Penetration' },
      { code: 'F', description: 'Appendages' },
      { code: 'G', description: 'Ultrasonic Examination' },
    ],
  },

  'Custom': {
    'Custom': [],
  },

  'Dike': {
    'Free format': [],
    'NEN 2767 (English)': [],
  },

  'Jetty (EN)': {
    'Free format': [],
  },

  'Overpass': {
    'Free format': [],
    'NEN 2767 (English)': [],
  },

  'Storage tank (NEN)': {
    'Free format': [],
    'NEN 2767 (English)': [],
  },

  'Windmill': {
    'Free format': [],
    'NEN 2767 (English)': [],
  },
};

export default IMAGE_CODES;